//导入模块
import page from '../components/page';
import page1 from '../components/page/page1';
import page2 from '../components/page/page2';
import page3 from '../components/page/page3';
import page4 from '../components/page/page4';
import page5 from '../components/page/page5';

export default{
    path:'/page',
    component:page,
    redirect:'/page/page1',
    children:[
        {path:'/page/page1',component:page1},
        {path:'/page/page2',component:page2},
        {path:'/page/page3',component:page3},
        {path:'/page/page4',component:page4},
        {path:'/page/page5',component:page5},
    ]
}



// WEBPACK FOOTER //
// ./src/router/page.js